document.addEventListener('DOMContentLoaded', () => {
	const mOpen = document.getElementById('m-open');
	const mOverlay = document.getElementById('m-overlay');
	const userTrigger = document.getElementById('m-user-trigger');
	const authBar = document.getElementById('m-auth-bar');

	if (!mOpen || !mOverlay || !userTrigger || !authBar) {
		return;
	}

	const openMenu = () => {
		if (document.body.classList.contains('menu-open')) {
			return;
		}

		document.body.classList.add('menu-open');
		mOverlay.style.display = 'block';
		history.pushState({ menu: 'open' }, '');
	};

	const closeMenu = () => {
		document.body.classList.remove('menu-open');
		mOverlay.style.display = 'none';
	};

	mOpen.addEventListener('click', openMenu);

	userTrigger.addEventListener('click', (e) => {
		e.stopPropagation();
		authBar.classList.toggle('active');
	});

	mOverlay.addEventListener('click', () => history.back());

	document.addEventListener('click', (e) => {
		if (!authBar.contains(e.target) && e.target !== userTrigger) {
			authBar.classList.remove('active');
		}
	});

	window.addEventListener('popstate', closeMenu);
});
